document.addEventListener('DOMContentLoaded', function() {

    console.log('DOM loaded');
      
    const ugcVideos = document.querySelectorAll('.ugcVideo');
  
    for (let v = 0; v < ugcVideos.length; v++) {
        
      const controls = ugcVideos[v].querySelector('.videoControls');
      const video = ugcVideos[v].querySelector('video');

      // initialise:
      if(v === 0){
        // video.volume = video.volume = 1;
      } else {
        video.pause();
        video.muted = true;
        video.volume = video.volume = 0;
      }
        
      controls.addEventListener('click', function() {

          if (controls.classList.contains('play')) {

              ugcVideos.forEach(function(video) {
                  video.querySelector('video').pause();
                  video.querySelector('video').volume = 0;
                  video.querySelector('.videoControls').classList.remove('pause');
                  video.querySelector('.videoControls').classList.add('play');
              });
            
              controls.classList.remove('play');
              controls.classList.add('pause');
              video.play();
              video.muted = false;
              video.volume = video.volume = 1;
          } else {
              controls.classList.remove('pause');
              controls.classList.add('play');
              video.pause();
              video.muted = true;
              video.volume = video.volume = 0;
          }

      });
        
    }
  
});